export const QuerySpaceAdminRepository = Symbol('QuerySpaceAdminRepository');
